import { Type, type Static } from "@sinclair/typebox";
import { UuidSchema } from "./identifiers.ts";

const Base64Url256Schema = Type.String({ pattern: "^[A-Za-z0-9_-]{43}$" });
const OAuthStateSchema = Type.String({ pattern: "^[A-Za-z0-9_-]{32,128}$" });
const UtcTimestampSchema = Type.String({
  pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d{1,9})?Z$"
});

export const WorkbenchLoginStartInputSchema = Type.Object(
  {
    authorizationUrl: Type.String({ minLength: 1, maxLength: 8192 }),
    completionUri: Type.String({ minLength: 1, maxLength: 2048 }),
    clientSecretHash: Base64Url256Schema
  },
  { additionalProperties: false }
);
export type WorkbenchLoginStartInput = Static<typeof WorkbenchLoginStartInputSchema>;

export const WorkbenchLoginPublicConfigurationSchema = Type.Object(
  {
    supabaseUrl: Type.String({ minLength: 1, maxLength: 2048 }),
    supabasePublishableKey: Type.String({ minLength: 1, maxLength: 4096 }),
    oauthClientId: UuidSchema
  },
  { additionalProperties: false }
);
export type WorkbenchLoginPublicConfiguration = Static<
  typeof WorkbenchLoginPublicConfigurationSchema
>;

export const WorkbenchLoginStartResultSchema = Type.Object(
  {
    transactionId: UuidSchema,
    authorizationUrl: Type.String({ minLength: 1, maxLength: 8192 }),
    expiresAt: UtcTimestampSchema
  },
  { additionalProperties: false }
);
export type WorkbenchLoginStartResult = Static<typeof WorkbenchLoginStartResultSchema>;

export const WorkbenchLoginRedeemInputSchema = Type.Object(
  {
    transactionId: UuidSchema,
    handoffCode: Base64Url256Schema,
    clientSecret: Base64Url256Schema
  },
  { additionalProperties: false }
);
export type WorkbenchLoginRedeemInput = Static<typeof WorkbenchLoginRedeemInputSchema>;

export const WorkbenchLoginRedeemResultSchema = Type.Object(
  {
    oauthState: OAuthStateSchema,
    authorizationCode: Type.String({ minLength: 1, maxLength: 4096 }),
    matrixLoginToken: Type.String({ minLength: 1, maxLength: 8192 })
  },
  { additionalProperties: false }
);
export type WorkbenchLoginRedeemResult = Static<typeof WorkbenchLoginRedeemResultSchema>;
